// Action Types
export const SET_PATH_NAME = "SET_PATH_NAME";
export const SET_TOKEN = "SET_TOKEN";
export const SET_USER = "SET_USER";
export const SET_LAB = "SET_LAB";
export const UPDATE_USER_PROFILE_STARTED = "UPDATE_USER_PROFILE_STARTED";
export const UPDATE_USER_PROFILE_SUCCESS = "UPDATE_USER_PROFILE_SUCCESS";
export const UPDATE_USER_PROFILE_ERROR = "UPDATE_USER_PROFILE_ERROR";
export const UPDATE_TOKEN = "UPDATE_TOKEN";
export const LOGOUT = "LOGOUT";
export const SEARCH_QUERY_CHANGE = "SEARCH_QUERY_CHANGE";
export const SEARCH_STARTED = "SEARCH_STARTED";
export const SEARCH_SUCCESS = "SEARCH_SUCCESS";
export const SEARCH_ERROR = "SEARCH_ERROR";
export const SEARCH_END = "SEARCH_END";
export const LAB_UPDATE_START = "LAB_UPDATE_START";
export const LAB_UPDATE_END = "LAB_UPDATE_END";
export const FETCH_USERS_START = "FETCH_USERS_START";
export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export const SET_MENU_STATUS = "SET_MENU_STATUS";
export const FETCH_QUICK_ACCESS_START = "FETCH_QUICK_ACCESS_START";
export const FETCH_QUICK_ACCESS_SUCCESS = "FETCH_QUICK_ACCESS_SUCCESS";
export const CREATE_NEW_USER_START = "CREATE_NEW_USER_START"
export const CREATE_NEW_USER_SUCCESS = "CREATE_NEW_USER_SUCCESS"
// Data types
//Reducer State Type
export interface SearchResultInterface {
    categories: any[],
    posts: any[],
    forms: any[],
    form_datas: any[]
}
export interface BaseState {
    path: string,
    token: string,
    user: UserInterface | any,
    users: UserInterface[] | [],
    lab: LabInterface | any,
    isLoading: boolean,
    searchQuery: string,
    searchResult :any,
    isSearching :boolean,
    isMainMenuOpen: boolean,
    quickAccess: QuickAccess[]
}
export interface QuickAccess {
    id: number,
    icon: string,
    title: string,
    form: number,
    category: number
}
export interface UserInterface {
    id: number,
    first_name: string,
    last_name: string,
    phone: string,
    email: string,
    avatar: any,
    avatar_id?:number,
    is_admin: boolean,
    signature_id?: number
}
export interface NewUserInterface {
    first_name: string,
    last_name: string,
    phone: string,
    email: string,
    avatar?: any,
    avatar_id?:number | null,
    signature_id?:number | null,
    password: string,
    password2: string
}
export interface LabInterface  {
    name :string,
    doctor :string,
    city :string,
    address :string,
    phone :string,
    logo :any
}
// Action Data Types
export interface SetPathName {
    type: typeof SET_PATH_NAME,
    path: string
}
export interface SetMenuStatus {
    type: typeof SET_MENU_STATUS,
    isOpen: boolean
}
export interface SetToken {
    type: typeof SET_TOKEN,
    token: string
}
export interface SetUser {
    type: typeof SET_USER,
    user: UserInterface
}
export interface SetLab {
    type: typeof SET_LAB,
    lab: any
}
export interface UpdateToken {
    type: typeof UPDATE_TOKEN,
}
export interface Logout {
    type: typeof LOGOUT,
}
export interface UpdateProfileStarted {
    type: typeof UPDATE_USER_PROFILE_STARTED
}
export interface UpdateProfileSuccess {
    type: typeof UPDATE_USER_PROFILE_SUCCESS,
    user : UserInterface
}
export interface changeSearchQuery {
    type: typeof SEARCH_QUERY_CHANGE,
    searchQuery: string
}
export interface SearchStarted {
    type: typeof SEARCH_STARTED
}
export interface SearchSuccess {
    type: typeof SEARCH_SUCCESS,
    result: SearchResultInterface
}
export interface SearchEnd {
    type: typeof SEARCH_END,
}
export interface UpdateLabStart {
    type: typeof LAB_UPDATE_START
}
export interface UpdateLabSuccess {
    type: typeof LAB_UPDATE_END,
    lab : LabInterface
}
export interface FetchUsersStart {
    type : typeof FETCH_USERS_START
}
export interface FetchUsersSuccess{
    type: typeof FETCH_USERS_SUCCESS,
    users: UserInterface[]
}
export interface FetchQuickAccessStart {
    type : typeof FETCH_QUICK_ACCESS_START
}
export interface FetchQuickAccessSuccess{
    type: typeof FETCH_QUICK_ACCESS_SUCCESS,
    quickAccess: QuickAccess[]
}
export interface CreateNewUserStart {
    type: typeof CREATE_NEW_USER_START,
}
export interface CreateNewUserSuccess {
    type: typeof CREATE_NEW_USER_SUCCESS,
    uer: NewUserInterface
}
export type ReactRouterActionTypes = SetPathName;
export type MenuActionTypes = SetMenuStatus;
export type AuthActionTypes = SetToken | SetUser | SetLab | UpdateToken | Logout | UpdateProfileStarted | UpdateProfileSuccess | SearchStarted | SearchSuccess | SearchEnd | UpdateLabStart | UpdateLabSuccess | FetchUsersStart | FetchUsersSuccess | changeSearchQuery;
export type QuickAccessTypes = FetchQuickAccessSuccess | FetchQuickAccessStart
export type CreateNewUser = CreateNewUserStart | CreateNewUserSuccess